import { IApiGateway } from '@/modules/api/api.interface'
import { IdResponseDto } from '@/shared/domain/entities/common.entity'

import { IEmailToSendRepository } from './emails-to-send.repository.interface'
import { CreateCustomEmailToSendBody } from './emails-to-send.schema'
import { EmailToSendResponse } from './emails-to-send.types'

export class EmailsToSendRepository implements IEmailToSendRepository {
  constructor(private api: IApiGateway) {}

  async get(id: string): Promise<EmailToSendResponse> {
    return this.api.get<EmailToSendResponse>(`emails-to-send/${id}`)
  }

  async createCustom(body: CreateCustomEmailToSendBody): Promise<IdResponseDto> {
    return this.api.post('emails-to-send/custom', body)
  }
}
